import { union, isEqual, isObject, isUndefined, isArray } from 'lodash';

function hasChanges(initial: any, current: any): boolean {
  // Если оба значения undefined - считаем что изменений нет
  if (isUndefined(initial) && isUndefined(current)) {
    return false;
  }

  // Если одно из значений undefined - считаем что изменений нет
  if (isUndefined(initial) || isUndefined(current)) {
    return false;
  }

  // Если значения не равны - есть изменения
  if (!isEqual(initial, current)) {
    return true;
  }

  return false;
}

function getChangedFieldsDeep<T extends object>(
  initial: T,
  current: Record<string, any>,
): Partial<T> {
  const keys = union(Object.keys(initial), Object.keys(current));
  const result: Partial<T> = {};

  for (const key of keys) {
    const initialValue = initial[key as keyof T];
    const currentValue = current[key];

    if (isUndefined(currentValue)) {
      continue;
    }

    if (isArray(initialValue) && isArray(currentValue)) {
      if (!isEqual(initialValue, currentValue)) {
        result[key as keyof T] = currentValue as T[keyof T];
      }
    } else if (isObject(initialValue) && isObject(currentValue)) {
      const nestedChanges = getChangedFieldsDeep(initialValue, currentValue);
      if (Object.keys(nestedChanges).length > 0) {
        result[key as keyof T] = currentValue as T[keyof T];
      }
    } else if (hasChanges(initialValue, currentValue)) {
      result[key as keyof T] = currentValue as T[keyof T];
    }
  }

  return result;
}

export function getChangedFields<T extends object>(
  initial: T,
  current: Record<string, any>,
): Partial<T> {
  console.log('initial', JSON.stringify(initial, null, 2));
  console.log('current', JSON.stringify(current, null, 2));

  return getChangedFieldsDeep(initial, current);
}
